export const LANGUAGE_KEYS = {
	EN: "en",
	TR: "tr"
};

export const API_BASE_URL = "https://api.tvmaze.com";